import { classNames } from '@payfit/growth-platform-brand-system-v2';

export const menuItemCn = classNames(
  'border-b border-neutral-21 border-opacity-40 xl:px-12 xl:py-4',
  'xl:rounded-[30px] xl:border-b-0',
  'bg-transparent xl:hover:bg-silver-40',
  'py-20',
  'flex items-center w-full xl:w-auto justify-between',
  'text-neutral-301 submenu-open:text-[#96A3B3]',
  'xl:group-hover:text-navy-200',
  'font-medium xl:font-normal',
  'px-4 -mx-4 xl:mx-0',
);
